<template>
    <div>
        <Header />
        <div v-if="global_loading" class="spinner-border space-above-container primary-text-color" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        <div v-else>
        <b-row>
            <b-col></b-col>
            <b-col>
                <h3 class="primary-text-color space-above-container"><strong>{{operation}}</strong></h3>
            </b-col>
            <b-col></b-col>
        </b-row>
        <b-row>
            <b-col></b-col>
            <b-col>
                <b-container class="space-above-container">
                    <b-row>
                        <span style="color:red">{{global_error}}</span>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-input class="space-above-form" v-model="data_model.name"
                                placeholder="Enter Application Name (Required)">
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-input class="space-above-form" v-model="data_model.tag"
                                placeholder="Enter Script tag  (Required)">
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-input class="space-above-form" v-model="data_model.for_os" placeholder="For OS">
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="space-above-container">
                        <b-col>
                            <h4 style="float:left">For docker Images</h4><span>(Required)</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <span style="color:red">{{docker_image_error}}</span>
                    </b-row>
                    <b-row>
                        <b-col cols="8">
                            <b-form-input class="space-above-form" v-model="docker_image" placeholder="Docker Images">
                            </b-form-input>
                        </b-col>
                        <b-col cols="4">
                            <b-button style="float:left;" class="space-above-form" @click="add_docker_images"><span
                                    class="white-font"><strong>Add</strong></span></b-button>
                        </b-col>
                    </b-row>
                    <b-row b-col v-for="dcim in docker_images" :key="'dcim'+dcim">
                        <b-col cols="8"> <label style="float:left;margin-left:10px" class="space-above-form"><strong>
                                    {{dcim}}
                                </strong></label></b-col>
                        <b-col cols="4">
                            <b-button style="float:left;margin-left:10px" class="space-above-form"
                                @click="remove_docker_image(dcim)"><span class="white-font"><strong>x</strong></span>
                            </b-button>
                        </b-col>

                    </b-row>
                    <b-row class="space-above-container">
                        <b-col>
                            <h4 style="float:left">Dependencies</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <span style="color:red">{{dependency_error}}</span>
                    </b-row>
                    <b-row>
                        <b-col cols="8">
                            <b-form-input class="space-above-form" v-model="dependency" placeholder="Dependencies">
                            </b-form-input>
                        </b-col>
                        <b-col cols="4">
                            <b-button style="float:left;" class="space-above-form" @click="add_dependency"><span
                                    class="white-font"><strong>Add</strong></span></b-button>
                        </b-col>
                    </b-row>

                    <b-row b-col v-for="dcpn in dependencies" :key="'dcpn'+dcpn">
                        <b-col cols="8"> <label style="float:left;margin-left:10px" class="space-above-form"><strong>
                                    {{dcpn}}
                                </strong></label></b-col>
                        <b-col cols="4">
                            <b-button style="float:left;margin-left:10px" class="space-above-form"
                                @click="remove_dependency(dcpn)"><span class="white-font"><strong>x</strong></span>
                            </b-button>
                        </b-col>

                    </b-row>

                    <b-row>
                        <b-form-textarea class="space-above-form" id="textarea" v-model="data_model.script"
                            placeholder="Enter your script (Required)" rows="3" max-rows="6"></b-form-textarea>
                    </b-row>
                    <b-row>
                        <b-form-textarea class="space-above-form" id="textarea" v-model="data_model.test_cmd"
                            placeholder="Enter your test command (Required)" rows="3" max-rows="6"></b-form-textarea>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-button class="space-above-form" style="min-width:150px; float:left;"
                                @click="script_test"><span class="white-font"><strong>Submit</strong></span></b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="!test_loading" class="space-above-form">
                        <span><strong><br></strong></span>
                    </b-row>
                </b-container>
            </b-col>
            <b-col></b-col>
        </b-row>
        </div>
    </div>
</template>

<script>
    import Header from './Header.vue';
    import axios from 'axios';
    import store from  '@/store/store';

    export default {
        name: 'Script',
        components: {
            Header
        },
        data() {
            return {
                data_model: {},
                docker_image: '',
                dependency: '',
                dependencies: [],
                docker_images: [],
                global_error: '',
                dependency_error: '',
                docker_image_error: '',
                test_result: false,
                operation: '',
                total_test_result: [],
                test_prompt: 'Perform Test before Create/Edit',
                global_loading: false,
                test_loading: false
            }
        },
        methods: {
            upsert() {
                this.dependency_error = '';
                this.docker_image_error = '';
                this.global_error = '';
                this.data_model.dependencies = this.dependencies;
                this.data_model.for_docker_images = this.docker_images;
                if (this.data_model.name && this.data_model.tag && this.data_model.user && this.data_model.script && this.data_model.test_cmd && this.data_model.for_docker_images.length) {
                    this.data_model.script = this.data_model.script.replace("\n", " && ");
                    this.data_model.test_cmd = this.data_model.test_cmd.replace("\n", " && ");
                    this.global_loading = true;
                    axios.post("https://9d0o217t3j.execute-api.us-east-1.amazonaws.com/Prod/global_installer_post", this.data_model, {
                            headers: {
                                Authorization: 'Bearer ' +store.state.id_token
                            }
                        }).then(
                        response => {
                            console.log(response);
                        }
                    ).catch(error=>{
                        this.global_loading = String(error);
                    }).finally(
                        ()=>{
                            this.global_loading = false;
                        }
                    );
                } else {
                    this.global_error = `Required parameters not enterd, Required params are "name", "tag", "script", "test_cmd", "for_docker_images"`;
                }

            },
            add_dependency() {
                this.dependency_error = '';
                if (this.dependency) {
                    if (this.dependencies.includes(this.dependency)) {
                        this.dependency_error = 'Duplicate Dependency'
                    } else {
                        this.dependencies.push(this.dependency);
                        this.dependency = '';
                    }

                } else {
                    this.dependency_error = 'Cannot add empty dependency'
                }

            },
            add_docker_images() {
                this.docker_image_error = '';
                if (this.docker_image) {
                    if (this.docker_images.includes(this.docker_image)) {
                        this.docker_image_error = "Duplicate docker image";
                    } else {
                        this.docker_images.push(this.docker_image)
                        this.docker_image = '';
                    }
                } else {
                    this.docker_image_error = 'Cannot add empty docker image';
                }

            },
            remove_dependency(dependency) {
                this.dependencies = this.dependencies.filter(dep => dep !== dependency);
            },
            remove_docker_image(docker_image) {
                this.docker_images = this.docker_images.filter(doc => doc != docker_image);
            },
            script_test() {
                this.total_test_result = [];
                const required_script = this.data_model.script;
                const required_test_cmd = this.data_model.test_cmd;
                if (!required_script) {
                    this.test_prompt = "Script is required to test";
                    return;
                }

                if (!required_test_cmd) {
                    this.test_prompt = "Test Command is required to test";
                }

                if (!this.docker_images.length) {
                    this.test_prompt = "Atleast one docker images is required";
                }

                const data_test = {
                    "user": store.state.user["cognito:username"],
                    "script": required_script.replace("\n", " && "),
                    "test_cmd": required_test_cmd.replace("\n", " && "),
                    "for_docker_images": this.docker_images,
                    "name": this.data_model.name,
                    "tag": this.data_model.tag
                };

                
                axios.post('https://0n7ecdnf2l.execute-api.us-east-1.amazonaws.com/Prod/global_installer_test', data_test, {
                headers: {
                        Authorization: 'Bearer '+store.state.id_token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$router.push({ name: 'User'});

                }).catch(error=>{
                    this.test_prompt = String(error);
                });
            }
        },
        created(){
            const user = store.state.user["cognito:username"];
            if (!user){
                //location.replace("https://authentication.simtekz.com/login?client_id=3l505p8r7gtfsd4upctv22f6nh&response_type=token&scope=email+openid+phone&redirect_uri=https://simtekz.com");
            }
        },
        mounted() {
            if ("add" === this.$route.params.script) {
                this.operation = "Create";
            } else {
                this.operation = "Edit";
                this.global_loading = true;
                axios
                    .get('https://9d0o217t3j.execute-api.us-east-1.amazonaws.com/Prod/global_installer_find_applications?search=' + this.$route.params.script)
                    .then(response => {
                        if (response && response['data'][0]) {
                            const required_data = response['data'][0];
                            const name_tag = required_data['title_name'].split(':');
                            this.$set(this.data_model, 'name', name_tag[0]);
                            this.$set(this.data_model, 'tag', name_tag[1]);
                            this.docker_images = required_data['display_name'] ? required_data['display_name'].split(',') : [];
                            this.dependencies = required_data['dependencies'] ? required_data['dependencies'] : [];
                            this.$set(this.data_model, 'user', required_data['user']);
                            this.$set(this.data_model, 'script', required_data.script.replace("&&", '\n'));
                            this.$set(this.data_model, 'test_cmd', required_data.test_cmd.replace("&&", '\n'));
                        }
                    }).catch(error=>{
                        console.log(String(error));
                    }).finally(
                        ()=>{
                            this.global_loading = false;
                        }
                    );
            }
        },
        computed: {
            watch_script_change() {
                return this.data_model.script;
            }
        },
        watch: {
            watch_script_change() {
                this.test_result = false;
            }
        }
    }
</script>

<style scoped>
    .space-above {
        margin-top: 60px;
        text-align: center;
    }

    .space-above-container {
        margin-top: 20px;
        text-align: center;
    }

    .space-above-form {
        margin-top: 10px;
    }

    .space-above-button {
        margin-top: 50px;
    }
</style>